var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"lazy-src":_vm.categoryImage,"src":_vm.categoryImage,"alt":'alternativeText',"eager":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }